// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/react/
import React from "react"
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router"

import { IS_PROD } from "@/lib/constants"
import * as Sentry from "@sentry/react"

// Only run browser sentry in production
if (IS_PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,

    integrations: [
      Sentry.browserProfilingIntegration(),
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        mask: [".sentry-mask"],
        unmask: [".sentry-unmask"],
        block: [".sentry-block"],
        unblock: [".sentry-unblock"],
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    enableLogs: true,

    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set `tracePropagationTargets` to declare which URL(s) should have trace propagation enabled
    tracePropagationTargets: [/^\//, /^https:\/\/getlumen\.com\/graphql/],

    // Capture Replay for 10% of all sessions,
    // plus 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    profileSessionSampleRate: 1.0,
  })
}
